import {stringInputValidation} from "../../helpers/commonFormValidationRules";

export default {
    companyName: stringInputValidation('companyName', 'Company Name', { max: 128 }),
    companyPib: stringInputValidation('companyPib', 'Company PIB'),
    zipCode: stringInputValidation('zipCode', 'Zip Code'),
    country: stringInputValidation('country', 'Country'),
    city: stringInputValidation('city', 'City'),
    street: stringInputValidation('street', 'Street', { max: 128 }),

    representativeFullName: stringInputValidation('representativeFullName', 'Representative Full Name'),
    email: [
        {required: true, message: `Please input Email!`},
        {max: 255, message: `Email cannot be longer than 255 characters`},
        {min: 2, message: `Email must be at least 2 characters`},
        {type: 'email', message: `Email is not valid!`}
    ],
    telephone: [{required: true, message: `Please input Phone Number!`}]
};

const companyFieldsBySteps = {
    '0': ['companyName', "companyPib", "zipCode", "country", "city", "street"],
    '1': ["representativeFullName", "email", "telephone"],
    '2': ['products']
};

const STEPS = [0, 1, 2];

export {companyFieldsBySteps, STEPS}